import {createAction} from '@reduxjs/toolkit';

export const setDefaultAlgoDuration = createAction<{duration?: number; initialLoad?: boolean}>('qepPreferences/setDefaultAlgoDuration');
